import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';

import PreviewStudy from '../../../../../core/components/preview-study-button';
import InstructionsSection from '../instructions-section';
import Section from '../section';

import {
  FieldName,
  FieldValue,
  Grid,
} from '../../styles';

const ProjectCardSortSummary = (props) => {
  const {
    baseUrl,
    history,
    values,
    onPreviewStudy,
    previewButtonClicked,
    smallColumn,
  } = props;

  const {
    cardSortCategories,
    cardSortItems,
    tooltipDescription,
    sortType,
  } = values;

  const {
    columns,
    width,
  } = useMemo(() => {
    const columnsValue = tooltipDescription ? 2 : 1;
    let widthValue = tooltipDescription ? 6 : 16;

    if (smallColumn) {
      widthValue = 4;
    }

    return ({
      columns: columnsValue,
      width: widthValue,
    });
  }, [smallColumn, tooltipDescription]);

  return (
    <>
      <InstructionsSection
        baseUrl={baseUrl}
        history={history}
        values={values}
        smallColumn={smallColumn}
      />
      <Section
        title="Cards"
        hasEdit={!!baseUrl}
        edit={() => history.push({ pathname: `${baseUrl}/cards`, state: null })}
      >
        <Grid>
          <Grid.Row columns={columns}>
            <Grid.Column width={width}>
              <FieldName>Name</FieldName>
            </Grid.Column>
            {tooltipDescription && (
              <Grid.Column width={10}>
                <FieldName>Description</FieldName>
              </Grid.Column>
            )}
          </Grid.Row>
          {cardSortItems && cardSortItems.map((item) => (
            <Grid.Row columns={columns} key={item.id}>
              <Grid.Column width={width}>
                <FieldValue>{item.name}</FieldValue>
              </Grid.Column>
              {tooltipDescription && (
                <Grid.Column width={10}>
                  <FieldValue>{item.description}</FieldValue>
                </Grid.Column>
              )}
            </Grid.Row>
          ))}
        </Grid>

        {!!onPreviewStudy && (
          <PreviewStudy
            onPreviewStudy={onPreviewStudy}
            loading={previewButtonClicked}
            loadingPosition="right"
          />
        )}
      </Section>

      {sortType !== 'opened' && (
        <Section
          title="Categories"
          hasEdit={!!baseUrl}
          edit={() => props.history.push({ pathname: `${baseUrl}/cards`, state: null })}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <FieldName>Name</FieldName>
              </Grid.Column>
            </Grid.Row>
            {cardSortCategories && cardSortCategories.map((category) => (
              <Grid.Row key={category.id}>
                <Grid.Column>
                  <FieldValue>{category.name}</FieldValue>
                </Grid.Column>
              </Grid.Row>
            ))}
          </Grid>

          {!!onPreviewStudy && (
            <PreviewStudy
              onPreviewStudy={onPreviewStudy}
              loading={previewButtonClicked}
              loadingPosition="right"
            />
          )}
        </Section>
      )}
    </>
  );
};

ProjectCardSortSummary.propTypes = {
  values: PropTypes.shape({
    instructionsContent: PropTypes.string,
    instructionsTitle: PropTypes.string,
    thankYouContent: PropTypes.string,
    thankYouTitle: PropTypes.string,
    tooltipDescription: PropTypes.bool,
    welcomeContent: PropTypes.string,
    welcomeTitle: PropTypes.string,
    sortType: PropTypes.string,
    cardSortItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    cardSortCategories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  baseUrl: PropTypes.string,
  onPreviewStudy: PropTypes.func,
  previewButtonClicked: PropTypes.bool,
  smallColumn: PropTypes.bool,
};

ProjectCardSortSummary.defaultProps = {
  baseUrl: undefined,
  onPreviewStudy: undefined,
  history: {},
  smallColumn: false,
  previewButtonClicked: false,
};

export default ProjectCardSortSummary;
